import type { Distance } from "@pdfking/math"
import { Quantize } from "@pdfking/quantity"
import { DISTANCE } from "@pdfking/quantity/constants"

/** A distance to the spec's precision (whole um): two lengths that quantize the
 * same are one line on the sheet. */
export const DistanceRound = (d: Distance): Distance => Quantize(d, DISTANCE)
